import Hero from '@/components/HeroSection'
import BookingCard from '@/components/BookingCard'
import { Box } from '@mui/material'
import Services from '@/components/Services'
import About from '@/components/Aboutus'
import Contact from '@/components/ContactMe'

export default function MainPage() {
  return (
    <Box>
        <Hero />
        <BookingCard />
        <Services />
        <About />
        <Contact />
      </Box>
  )
}
